import type { UserContext } from "./types";

/**
 * Usuários criados com senha temporária (admin_federacao via admin global
 * ou usuario_clube via admin de federação / admin global) precisam passar
 * pelo wizard de primeiro acesso antes de acessar sua área:
 *   1. trocar senha;
 *   2. completar cadastro com docs;
 *   3. aguardar aprovação do admin global.
 *
 * Oficial auto-registrado (`/registro/oficial`) nasce `aguardando_aprovacao` e espera o clube/federação;
 * oficial criado pela federação tem `statusAprovacao` NULL e entra direto. admin_global não tem o fluxo.
 */
export function needsOnboarding(user: UserContext | null | undefined): boolean {
  if (!user) return false;
  const tiposComOnboarding = ["admin_federacao", "usuario_clube", "atleta", "responsavel", "oficial"] as const;
  if (!tiposComOnboarding.includes(user.tipo as (typeof tiposComOnboarding)[number])) return false;
  if (user.senhaTemporaria) return true;
  const s = user.statusAprovacao;
  if (s && s !== "aprovado") return true;
  return false;
}
